// 获取站内信消息列表
export const GET_LETTER_LIST = "GET_LETTER_LIST";
// 获取站内信消息详情
export const GET_LETTER_DETAIL = "GET_LETTER_DETAIL";
// 获取未读消息条数
export const GET_UNREAD_NUM = "GET_UNREAD_NUM";
// 批量修改站内信消息已读状态
export const BATCH_SET_LETTER_READ = "BATCH_SET_LETTER_READ";


// WEBPACK FOOTER //
// ./src/store/letter/type.js